<script setup>
import {computed, onMounted, onUnmounted, reactive} from "vue";
import countdown from '@/StandaloneJS/vue-countdown';
import {ApiWrapper} from "@/Utils/ApiWrapper";
import {Permissions} from "@/Utils/Permissions";
import {ToastUtil} from "@/Utils/ToastUtil";
import {activeComponentStore} from "@/Stores/ActiveComponentStore";

const props = defineProps({
  contextSchemaA: String
});

const compName = 'TasksPendingAcctMgrAttnNeeded';

onMounted(() => {
  getData();

  activeComponentStore.registerComponent(
      compName,
      [
        'tasks'
      ],
      getData
  );
});

onUnmounted(() => {
  activeComponentStore.deregisterComponent(compName);
});

const data = reactive({
  loading: false,
  search: null,
  dataLoading: true,
  newAdj: false,
  headers: [
    { title: 'Claim Number', key: 'claimnumber' },
    { title: 'Claim Age (Days)', key: 'age' },
    { title: 'Note', key: 'description' },
    { title: 'Time Remaining', key: 'timedue',},
    { title: 'Adjuster', key: 'adjuster' },
    { title: 'Client', key: 'clientname' }
  ],
  items: [],
});

const getData = () => {
  data.dataLoading = true
  ApiWrapper.post('tasks-pending','list-tasks-pending-acct-mgr-attn-needed', {
  })
      .then((response) => {
        data.items = response.tasks;
      })
      .catch((error) => {
        ToastUtil.error(error);
      })
      .finally(() => {
        data.dataLoading = false
      });
}

const GetIsFireType = (claim) => {
  if(claim.claimtype) {
    return claim.claimtype.toString().toLowerCase().includes('fire')
  }
  return false;
};

</script>

<template>
  <v-container fluid id="entreos-resize-target">
    <v-card class="elevation-2" height="auto" width="auto">
      <v-toolbar flat color="white">
        <v-toolbar-title>Tasks Pending - Account Manager Attention/Review Needed</v-toolbar-title>

        <v-divider class="mx-4" inset vertical></v-divider>
      </v-toolbar>
      <v-row>
        <v-col cols="4">
          <v-text-field v-model="data.search" append-inner-icon="mdi-magnify" label="Search" single-line hide-details
                        class="ml-4"></v-text-field>
        </v-col>
        <v-col>
          <v-btn icon variant="flat" class="mt-1" @click="getData()">
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-data-table :items="data.items" :headers="data.headers" item-value="tasksid" :search="data.search"
                    :loading="data.dataLoading" loading-text="Loading... Please wait" :items-per-page-options="[-1, 50, 100, 200]">
        <template v-slot:[`item.claimnumber`]="{ item }">
          <RouterLink :to="`/claim/${item.claimid}`">
            {{ item.claimnumber }}
          </RouterLink>
          <span class="ma-ml-3" v-if="GetIsFireType(item)"> <v-icon color="orange">mdi-fire-circle</v-icon> </span>
        </template>

        <template v-slot:[`item.personname`]="{ item }">
          <RouterLink :to="`/userprofile/${item.personid}`">
            {{ item.personname }}
          </RouterLink>
        </template>
        <template v-slot:[`item.clientname`]="{ item }">
          <RouterLink :to="`/client/${item.clientid}`" v-if="Permissions.checkPermissions(['clients.read'])">
            {{ item.clientname }}
          </RouterLink>
          <span v-else>{{ item.clientname }}</span>
        </template>
        <template v-slot:[`item.timedue`]="{item}">
          <v-chip label v-if="new Date(item.timedue) - new Date() > 0" class="success text--white">
            <v-icon dark left>mdi-calendar</v-icon>
            <countdown :time="new Date(item.timedue) - new Date()">
              <template v-slot="props">
                {{ props.totalHours.toString().padStart(2, 0) }}:{{
                  props.minutes.toString().padStart(2, 0)
                }}:{{
                  props.seconds.toString().padStart(2, 0)
                }}
              </template>
            </countdown>
          </v-chip>
          <v-chip label v-else-if="!item.timecompleted" class="error text--white">
            <v-icon dark left>mdi-calendar</v-icon>
            <countdown :time="new Date() - new Date(item.timedue)" :interval="-1000">
              <template v-slot="props">
                {{ props.totalHours.toString().padStart(2, 0) }}:{{
                  props.minutes.toString().padStart(2, 0)
                }}:{{
                  props.seconds.toString().padStart(2, 0)
                }}
              </template>
            </countdown>
          </v-chip>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>